import React from 'react';
import { Breadcrumbs, Link as MuiLink, Typography } from '@mui/material';
import { NavigateNext as NavigateNextIcon } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';

const DetailBreadcrumbs = ({ items }) => {
  const trail = (items || []).filter(Boolean);
  if (trail.length === 0) return null;

  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label="breadcrumb"
      sx={{ mb: 2 }}
    >
      {trail.map((item, idx) => {
        const isLast = idx === trail.length - 1;
        if (isLast || !item.to) {
          return (
            <Typography key={idx} color="text.primary" noWrap>
              {item.label}
            </Typography>
          );
        }
        return (
          <MuiLink
            key={idx}
            component={RouterLink}
            to={item.to}
            underline="hover"
            color="inherit"
          >
            {item.label}
          </MuiLink>
        );
      })}
    </Breadcrumbs>
  );
};

export default DetailBreadcrumbs;
